

import { Component, Prop } from 'vue-property-decorator';
import ErrorMessageHandlerMixin from '../misc/ErrorMessageHandler.mixin';
import { mixins } from 'vue-class-component';
import { countries, Country } from '@/misc/allCountries';
import getCountry from '../misc/defaultCountry';

@Component
export default class CountyCodeComponent extends mixins(ErrorMessageHandlerMixin) {
    @Prop({ default: false })
    public disabledFetchingCountry!: boolean;

    @Prop({ default: false })
    public disabled!: boolean;

    @Prop({ default: false })
    public disabledFormatting!: boolean;

    @Prop({ default: '' })
    public defaultCountry!: string;

    @Prop({ default: true })
    public enabledCountryCode!: boolean;

    @Prop({ default: true })
    public enabledFlags!: boolean;

    @Prop({ default: false })
    public selectedCountryCode!: boolean

    private activeCountry: Country = { name: 'Namibia', iso2: 'NA', dialCode: '264' };

    public get allCountries() {
        return countries;
    }

    mounted() {
        this.initializeCountry();
        this.choose(this.activeCountry);
    }

    public initializeCountry() {
        if (this.defaultCountry) {
            const dialCodeToCheck = this.defaultCountry.replaceAll('+', '');
            const defaultCountry = this.findCountryByDialCode(dialCodeToCheck);
            if (defaultCountry) {
                this.activeCountry = defaultCountry;
                return;
            }
        }

        if (!this.disabledFetchingCountry) {
            getCountry().then(res => {
                this.choose(this.findCountry(res) || this.activeCountry);
            });
        }
    }

    public choose(country: Country) {
        this.$emit('onSelect', country);
    }

    public findCountry(iso: string = ''): Country | undefined {
        return countries.find(country => country.iso2 === iso.toUpperCase());
    }

    public findCountryByDialCode(dialCode: string): Country | undefined {
        return countries.find(country => country.dialCode === dialCode);
    }
}
